export enum AttorneyListEnums {
    SH = 290698,
    MC = 308503,
    EF = 503185,
    DB = 580873,
    HC = 606941
}